<div>
    <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Suchen</mat-label>
        <input
            [formControl]="searchCtrl"
            matInput
            placeholder="Name oder VVVO"
            type="search"
            [attr.data-cy]="'mkmkmk_input_1_1_'"
        />
        <mat-icon matPrefix [attr.data-cy]="'mkmkmk_mat-icon_1_2_'">search</mat-icon>
        <button
            mat-icon-button
            matSuffix
            (click)="searchCtrl.setValue(undefined)"
            [attr.data-cy]="'mkmkmk_button_1_0_'"
        >
            <mat-icon [attr.data-cy]="'mkmkmk_mat-icon_2_2_'">clear</mat-icon>
        </button>
    </mat-form-field>

    <div *ngIf="neuenKontaktErstellen && kunde_id" class="one-row" style="padding-bottom: 20px">
        <span class="spacer"></span>
        <button (click)="neuenKontakt()" color="accent" mat-stroked-button [attr.data-cy]="'mkmkmk_button_2_0_'">
            <mat-icon [attr.data-cy]="'mkmkmk_mat-icon_3_2_'">add</mat-icon>
             neuen {{ titel }} anlegen
        </button>
        <span class="spacer"></span>
    </div>

    <mat-card *ngFor="let k of kontakte" style="margin-bottom: 24px">
        <mat-card-title>{{ k.bezeichnung }}</mat-card-title>
        <mat-card-subtitle *ngIf="k.zusatz">{{ k.zusatz }}</mat-card-subtitle>
        <div>
            <p>VVVO: {{ k.vvvo ? k.vvvo : "---" }}</p>
            <p>{{ k.strasse }}</p>
            <p>{{ k.plz }} {{ k.ort }}</p>
        </div>
        <mat-card-actions align="end">
            <button (click)="kontaktAuswaehlen(k)" color="accent" mat-flat-button [attr.data-cy]="'mkmkmk_button_3_0_'">
                <mat-icon [attr.data-cy]="'mkmkmk_mat-icon_4_2_'">check</mat-icon>
                ausw&auml;hlen
            </button>
        </mat-card-actions>
    </mat-card>
</div>
